import { TextField, Stack, InputAdornment, Button } from "@mui/material"
import { useState } from "react"
import SearchRoundedIcon from "@mui/icons-material/SearchRounded"
import InstitutionCard from "../cards/InstitutionCard"
import AddInstitution from "../modals/AddInstitution"
import DeleteInstitution from "../modals/DeleteInstitution"
import { getAllInstitutions, getInstitutionFilters, getInstitutionSort } from "../../api"

import ListData from "../common/ListData"

const Institutions = () => {
    const [search, setSearch] = useState("")
    const [editModal, setEditModal] = useState(false)
    const [deleteModal, setDeleteModal] = useState(false)
    const [selectedItem, setSelectedItem] = useState(null)
    const [fetchData, setFetchData] = useState(false)

    const handleSearchChange = (event) => setSearch(event.target.value)

    const openEditModal = (item) => {
        setSelectedItem(item)
        setEditModal(true)
    }
    const closeEditModal = () => setEditModal(false)
    const openDeleteModal = (item) => {
        setSelectedItem(item)
        setDeleteModal(true)
    }
    const closeDeleteModal = () => setDeleteModal(false)

    const CTA = () => (
        <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
            <TextField
                value={search}
                onChange={handleSearchChange}
                placeholder="Search Institutions..."
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchRoundedIcon />
                        </InputAdornment>
                    ),
                }}
            />
            <Button onClick={() => openEditModal(null)} variant="contained">
                Add Institution
            </Button>
        </Stack>
    )

    return (
        <>
            <ListData
                getFilters={getInstitutionFilters}
                getSort={getInstitutionSort}
                getAllData={getAllInstitutions}
                initialFilters={{ sort: { field: 'name', order: 'desc' } }}
                HeaderRight={CTA}
                Card={InstitutionCard}
                openEditCard={openEditModal}
                openDeleteCard={openDeleteModal}
                refresh={fetchData}
                type="CARD"
            />

            <AddInstitution
                isOpen={editModal}
                close={closeEditModal}
                data={selectedItem}
                refresh={() => {
                    setFetchData(!fetchData)
                }}
            />
            <DeleteInstitution
                isOpen={deleteModal}
                close={closeDeleteModal}
                data={selectedItem}
                refresh={() => {
                    setFetchData(!fetchData)
                }}
            />
        </>
    )
}

export default Institutions